import React, { useEffect, useState } from "react";
import { fetchJson, post } from "../../lib/Fetching";
import Button from "../Button";
import Select from "react-select";
import NotificationMechanismsSelect from "./NotificationMechanismsSelect";
import TestQueryParametersSelect from "./TestQueryParametersSelect";
import PeopleSelect from "./PeopleSelect";
import CompanyBranchesSelect from "./CompanyBranchesSelect";
import { MinimalContainer } from "../sample_reporting/Theme";
import styled, { css } from "styled-components";
import Checkbox from "../common/form/Checkbox";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const Container = styled(MinimalContainer)`
  padding: 20px;
  max-width: 1920px;
  margin: 0 auto;
`;

export default function NotificationGroupForm({ newGroup, handleGroupSubmit, clientView }) {
  const [group, setGroup] = useState(newGroup);

  const handleSubmit = (e) => handleGroupSubmit(group);

  const handleSelectChange = (name) => (options) =>
    setGroup({
      ...group,
      [name]: Array.isArray(options) ? options.map((i) => i.value) : [options.value],
    });

  const handleSingleValueSelectChange = (name) => (option) =>
    setGroup({
      ...group,
      [name]: option ? option.value : null,
    });

  const company_id = group.company_id;

  return (
    <Container>
      <div className="panel-body">
        <div className="row">
          <div className="col-md-4">
            <label>Start Time</label>
            <br />
            <DatePicker
              selected={group.start_time_at}
              onChange={(date) =>
                setGroup({
                  ...group,
                  start_time_at: date,
                })
              }
              showTimeSelect
              timeFormat="HH:mm"
              timeIntervals={15}
              timeCaption="time"
              dateFormat="MMMM d, yyyy h:mm aa"
              className="form-control"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <label>Select Test Query Parameters</label>
            <TestQueryParametersSelect
              handleSelectChange={handleSingleValueSelectChange("test_query_parameter_id")}
              selectedId={group.test_query_parameter_id}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <label>Filter by Samples Registered At</label>
            <CompanyBranchesSelect
              handleSelectChange={handleSelectChange("company_branch_ids")}
              company_id={company_id}
              company_branch_ids={group.company_branch_ids}
            />
          </div>
          <div className="col-md-4">
            <label>Select Notification Methods</label>
            <NotificationMechanismsSelect
              handleSelectChange={handleSelectChange("notification_mechanism_ids")}
              notification_mechanism_ids={group.notification_mechanism_ids}
            />
          </div>

          <div className="col-md-4">
            <label>Select People to Notify</label>
            <PeopleSelect
              handleSelectChange={handleSelectChange("person_ids")}
              company_id={company_id}
              people_ids={group.person_ids}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <br />
            <Button primary onClick={handleSubmit} title={I18n.t("save")} />
            {group.id && (
              <div className="alert alert-warning" style={{ marginBottom: 0, marginTop: 20 }}>
                WARNING: Any changes you make to test parameters will only apply to new
                results, or results added since the 'Results Processed Up To' date above.
              </div>
            )}
          </div>
        </div>
      </div>
    </Container>
  );
}
